import { Close, Launch } from "@mui/icons-material";
import { Button, Dialog } from "@mui/material";

import { useHistoryNavigate } from "../../../../../../../hooks/useHistoryNavigate";
import FormatISODateTime from "../../../../../../global/FormatISODateTime";

export default function ViewCompletedActionItem({
  openCompleteModal,
  title,
  selectedActionItem,
  handleClose,
}) {
  const { historyNavigate } = useHistoryNavigate();

  function navigateToCaseDetail(id) {
    historyNavigate("client-detail", id);
  }
  return (
    <div id="Follow-Up-View" data-testid="Follow-Up-View">
      <Dialog
        open={openCompleteModal}
        fullWidth
        maxWidth="lg"
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0)",
        }}
      >
        <div className="outer p-2 text-center">
          <div className="text-right">
            <Button onClick={() => handleClose(false)}>
              <Close />
            </Button>
          </div>
          <div className="text-left"> </div>
          <div className="p-2 text-center"></div>
          <div className="text-[2rem]">{title}</div>
          <div className="border-1 border-solid border-slate-500 p-4 text-left">
            {selectedActionItem?.name && (
              <div className="border-1 border-solid border-slate-500 text-left">
                <span className="font-bold">Name:</span> {selectedActionItem?.name}
              </div>
            )}
            {selectedActionItem?.clientName && (
              <div>
                <span className="font-bold">Client Name:</span> {selectedActionItem?.clientName}
              </div>
            )}
            {selectedActionItem?.accidentDate && (
              <div>
                <span className="font-bold">Client Accident Date:</span>{" "}
                {selectedActionItem?.accidentDate}
              </div>
            )}

            <div>
              {selectedActionItem?.actingUserName && (
                <>
                  <span className="font-bold">Acting User:</span>{" "}
                  <span className="text-[1.25rem]">{selectedActionItem?.actingUserName}</span>
                </>
              )}
            </div>
            {selectedActionItem?.priorityDate && (
              <div>
                <span className="font-bold">Priority Due Date:</span>{" "}
                <span className="text-[1.25rem]">
                  {selectedActionItem?.dueDate && FormatISODateTime(selectedActionItem?.dueDate)}
                </span>
                <span className="italic">
                  {selectedActionItem?.relativeDueDate &&
                    " (" + selectedActionItem?.relativeDueDate + ")"}
                </span>
              </div>
            )}
            <div>
              <span className="font-bold">Due Date:</span>{" "}
              <span className="text-[1.25rem]">
                {selectedActionItem?.dueDate && FormatISODateTime(selectedActionItem?.dueDate)}
              </span>
              <span className="italic">
                {selectedActionItem?.relativeDueDate &&
                  " (" + selectedActionItem?.relativeDueDate + ")"}
              </span>
            </div>
            {selectedActionItem?.onCase?.comboName && (
              <div className="text-left">
                <span className="font-bold">Client:</span> {selectedActionItem?.onCase?.comboName}{" "}
                <Button
                  title="Open Case Details"
                  className="text-sky-600 hover:bg-sky-600 hover:text-white"
                  onClick={() =>
                    navigateToCaseDetail(
                      selectedActionItem?.onCase?.id ?? selectedActionItem?.onCase?.pk
                    )
                  }
                >
                  Navigate to Case <Launch />
                </Button>
              </div>
            )}

            {selectedActionItem?.lawFirmName && (
              <div className="border-1 border-solid border-slate-500 py-4 text-left">
                <span className="font-bold">Law Firm:</span> {selectedActionItem?.lawFirmName}
              </div>
            )}
            {selectedActionItem?.onProvider?.name && (
              <div className="border-1 border-solid border-slate-500 py-4 text-left">
                <span className="font-bold">Provider:</span> {selectedActionItem?.onProvider?.name}
              </div>
            )}
            {selectedActionItem?.shortDescription && (
              <div>
                <span className="font-bold">Follow-up Details:</span>{" "}
                {selectedActionItem?.shortDescription}
              </div>
            )}
          </div>
          <div className="border-1 border-solid border-slate-500 p-4 text-left">
            <span className="font-bold">Status:</span>{" "}
            <span className="uppercase">
              {selectedActionItem?.status && selectedActionItem?.status === "pending"
                ? "In-Complete"
                : "Complete"}
            </span>
            {selectedActionItem?.completedByName && (
              <div className="text-[0.85rem]">
                <span className="font-bold">Completed By:</span>{" "}
                {selectedActionItem?.completedByName}
              </div>
            )}
            {selectedActionItem?.completedAt && (
              <div className="text-[0.85rem]">
                <span className="font-bold">Completed At:</span>{" "}
                {FormatISODateTime(selectedActionItem?.completedAt)}
              </div>
            )}
          </div>
        </div>
      </Dialog>
    </div>
  );
}
